export default {
  bl: true,
  br: true,
  tl: false,
  tr: false,
  mb: false,
  ml: false,
  mr: false,
  mt: false,
  mtr: true,
};
